module.exports = __webpack_public_path__ + "assets/img/d9094c303861ee9bef02caf8fc79821b.png";